import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";
import { fieldSlotMinHeight } from "@shared/SectionPanel/SectionField";

export const useStyles = makeStyles()((theme: Theme) => ({
    column: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        minWidth: 0,
    },
    columnEditing: {
        gap: theme.spacing(1.5),
        // The panels are full width now, and a text input stretched across the whole page reads as
        // anything but a form field. Cap the editing column at a normal form measure instead.
        maxWidth: 560,
    },
    inputSlot: {
        display: "flex",
        flexDirection: "column",
        // Top-aligned rather than centered: minHeight reserves room for the error text below the
        // input, and top-alignment means that reserved space is consumed downward when the error
        // appears instead of re-centering (and shifting) the input itself.
        justifyContent: "flex-start",
        minWidth: 0,
        minHeight: fieldSlotMinHeight,
    },
}));
